import React, { useState } from 'react'
import PropTypes from 'prop-types'
import './SearchBar.scss'
import lang from '../language/services/Lang'
import { useSelector } from 'react-redux'
import { Fragment } from 'react'
import Button from '../library/buttons/Button'

const SearchBar = props => {

    const { elementId, placeholderKey, maxLength, performSearch, defaultValue, showButton } = props

    const [searchString, setSearchString] = useState(defaultValue)

    const placeholderText = useSelector(state => lang.getValue(placeholderKey, state.layout.lang))

    const onChange = e => {
        setSearchString(e.target.value ? e.target.value.trim() : null)
    }

    const onKeyDown = e => {
        if (props.allowEmptySearch && e.keyCode === 13 && !searchString && performSearch) {
            performSearch('')
        } else if ((e.keyCode === 13) && searchString.length > 0 && performSearch) {
            performSearch(searchString)
        }
    }

    const onFocus = e => {
        e.target.select()
        e.target.placeholder = ''
    }

    const onBlur = e => {
        e.target.placeholder = placeholderText
    }

    const onSearch = (e) => {
        if (props.allowEmptySearch && !e.target.value && performSearch) {
            performSearch('')
        }
    }

    return (
        <Fragment>
            <input id={elementId} type='search' name='search'
                className='search-bar input is-rounded is-shadowless'
                placeholder={placeholderText}
                maxLength={maxLength}
                onChange={e => { onChange(e) }}
                onKeyDown={e => { onKeyDown(e) }}
                onFocus={e => { onFocus(e) }}
                onBlur={e => { onBlur(e) }}
                ref={el => (el || {}).onsearch = onSearch}
                defaultValue={defaultValue} />
            {showButton &&
                <Button elementId={`${elementId}-btn`} buttonStyles='secondary search' onClick={() => performSearch(searchString)} disabled={!searchString} labelKey='ManageTicket.SearchButton' />
            }
        </Fragment>)
}

SearchBar.propTypes = {
    elementId: PropTypes.string.isRequired,
    placeholderKey: PropTypes.string.isRequired,
    performSerach: PropTypes.func,
    showButton: PropTypes.bool,
    maxLength: PropTypes.number,
    allowEmptySearch: PropTypes.bool
}

export default SearchBar
